export default (searchTerm, strings) =>
  (Array.isArray(strings) ? strings : [strings])
    .filter(value => typeof value === 'string')
    .some(text => {
      const searchArray = searchTerm
        .trim()
        .toLowerCase()
        .split(/\.|\s|;|,/);
      const cleanedString = text
        .trim()
        .toLowerCase()
        .split(/\.|\s|;|,/);
      return searchArray.every(string => cleanedString.some(word => word.startsWith(string)));
    });
